import b from "@emotion/styled/base";
import { Stack as c } from "../../Stack/index.js";
function d() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const i = /* @__PURE__ */ b(c, process.env.NODE_ENV === "production" ? {
  target: "ei0uccb1"
} : {
  target: "ei0uccb1",
  label: "FileDetails"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvRHJvcHpvbmUvUmVqZWN0ZWRTaW5nbGVEb2N1bWVudFRodW1iL1JlamVjdGVkU2luZ2xlRG9jdW1lbnRUaHVtYi5zdHlsZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSThEIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvRHJvcHpvbmUvUmVqZWN0ZWRTaW5nbGVEb2N1bWVudFRodW1iL1JlamVjdGVkU2luZ2xlRG9jdW1lbnRUaHVtYi5zdHlsZWQudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkLCB7IFN0eWxlZENvbXBvbmVudCB9IGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IFN0YWNrIH0gZnJvbSAnLi4vLi4vU3RhY2snO1xuXG5leHBvcnQgY29uc3QgRmlsZURldGFpbHM6IFN0eWxlZENvbXBvbmVudDxhbnk+ID0gc3R5bGVkKFN0YWNrKWBcbiAgICB3aWR0aDogMTAwJTtcbmA7XG5cbmV4cG9ydCBjb25zdCBBY3Rpb25Db250YWluZXI6IFN0eWxlZENvbXBvbmVudDxhbnk+ID0gc3R5bGVkKFN0YWNrKWBgO1xuIl19 */",
  toString: d
});
process.env.NODE_ENV;
export {
  i as FileDetails
};
